const stats = [
  { value: "100%", label: "Privacy Focused", icon: "ri-shield-line" },
];

const values = [
  {
    icon: "ri-code-s-slash-line",
    title: "Engineering Excellence",
    desc: "We follow iOS best practices and Apple Human Interface Guidelines to build polished, native-quality apps.",
  },
  {
    icon: "ri-lock-password-line",
    title: "Security First",
    desc: "User data protection is at the core of everything we build. We implement best-in-class encryption and privacy standards.",
  },
  {
    icon: "ri-flashlight-line",
    title: "Performance Obsessed",
    desc: "Our apps are optimized for speed, low battery usage, and smooth interactions — even on older iPhone models.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "User-Centric Design",
    desc: "We design intuitive, minimal interfaces that feel at home on iOS — reducing friction and enhancing daily usability.",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16 md:mb-20">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-emerald-600 mb-3 block">
            About Us
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 tracking-tight mb-4">
            Who We Are
          </h2>
          <p className="text-gray-500 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            IDEL SH.P.K. is a dedicated iOS development studio based in Albania, building applications that make mobile life safer, faster, and smarter.
          </p>
        </div>

        {/* Story + Image */}
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20 mb-20 md:mb-28">
          <div className="w-full lg:w-1/2">
            <img
              src="https://public.readdy.ai/ai/img_res/1ae580c6cc5ea4ca6b4a64eadacf994f.jpg"
              alt="IDEL SH.P.K. development team"
              className="w-full h-72 md:h-96 object-cover object-top rounded-2xl"
            />
          </div>
          <div className="w-full lg:w-1/2">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-5 tracking-tight">
              A Team Passionate About iOS
            </h3>
            <p className="text-gray-500 text-base leading-relaxed mb-4">
              Founded by a group of passionate iOS engineers and designers, IDEL SH.P.K. was built with a single mission: to create applications that genuinely improve people&apos;s digital lives.
            </p>
            <p className="text-gray-500 text-base leading-relaxed mb-4">
              Our expertise spans across mobile security, system optimization, and intuitive UX design. Every product we release goes through rigorous testing to ensure stability, speed, and compliance with Apple&apos;s strict App Store standards.
            </p>
            <p className="text-gray-500 text-base leading-relaxed">
              We believe great software is invisible — it just works. Our goal is to build tools that blend seamlessly into your daily routine while offering powerful capabilities under the hood.
            </p>
          </div>
        </div>

        {/* Stats */}
        <div className="flex justify-center mb-20 md:mb-28">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-gray-50 rounded-2xl p-6 md:p-8 text-center w-48"
            >
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-xl bg-emerald-50">
                <i className={`${stat.icon} text-emerald-600 text-xl`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-gray-900 mb-1">{stat.value}</div>
              <div className="text-gray-500 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Values */}
        <div className="text-center mb-12">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 tracking-tight mb-3">Our Core Values</h3>
          <p className="text-gray-500 text-base max-w-xl mx-auto">The principles that guide how we build, ship, and support every product.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((val) => (
            <div
              key={val.title}
              className="bg-gray-50 rounded-2xl p-6 hover:bg-gray-100 transition-colors duration-200"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-emerald-50 mb-4">
                <i className={`${val.icon} text-emerald-600 text-xl`}></i>
              </div>
              <h4 className="text-gray-900 font-semibold text-base mb-2">{val.title}</h4>
              <p className="text-gray-500 text-sm leading-relaxed">{val.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
